export enum Routes {
  Root = "/",
  NotFound = "/404",
  Login = "/login",
  Logout = "/logout",
  Settings = "/settings",
  SettingsProfile = "/settings/profile",
  SettingsOrganizations = "/settings/organizations",
  SettingsUsers = "/settings/users",
  SettingsBots = "/settings/bots",
  SettingsUiPreferences = "/settings/ui-preferences",
  SettingsUiBranding = "/settings/ui-branding",
  AppChat = "/app/chat",
  AppSearch = "/app/search",
}

export const DEFAULT_ROUTE_AFTER_LOGIN = Routes.AppChat;

export const Layout = {
  SidebarWidth: 300,
};

export enum AppType {
  Search = "search",
  Docs = "docs",
  Audio = "audio",
  Translation = "translation",
}
